<template>
  <div class="container">
    <div class="columns">
      <div class="column col-8 col-md-12"> 
        <form class="float-left">
          <div class="input-group">
            <input class="form-input" type="text" id="visaTypeName" v-model="newTypeField" placeholder="Create new visa type">  
            <button type="submit" class="btn btn-primary input-group-btn" @click="addType">
              <i class="icon icon-plus"></i>
            </button>
            <button class="btn input-group-btn" @click="importType" style="color:#136efb; border-color: #136efb">
              <i class="icon icon-upload"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="divider"></div>

    <div class="container">
      <div class="columns">
        <div class="column col-8 col-md-12">
          <div v-for="(type, index) in visatypes">
            <div class="visatype">
              <h3><a href="" @click.prevent="editType(type)">{{type.name}}</a></h3>
              <div class="tile-action">
                <button class="btn" @click="editType(type)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                <button class="btn" @click="exportType(type)"><i class="fa fa-download" aria-hidden="true"></i></button>
                <button class="btn" @click="delType(index)"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'

export default {
  name: 'visatypes',
  mixins: [utils],
  data () {
    return {
      typeIndex: -1,
      visatypes: [],
      newTypeField: '',
      error: false
    }
  },
  created: function () {
    this.$root.$data.pageTitle = 'Visa Types'
    this.getTypes()
  },
  methods: {
    getTypes: function () {
      axios.get('/api/allvisatypes').then(res => {
        if (res.data) {
          this.visatypes = res.data
        }
      })
      .catch(e => { console.log(e) })
    },
    addType: function () {
      var name = this.newTypeField.trim()
      if (name === '') {
        return
      }
      axios.post('/api/new/visatypes', {
        name: name,
        sections: [],
        doctypes: []
      })
      .then(res => {
        if (res.status === 200) {
          this.visatypes.push(res.data)
          this.newTypeField = ''
        }
      })
      .catch(e => { console.log(e) })
    },
    delType: function (index) {
      axios.post('/api/delete/visatypes/' + this.visatypes[index]._id)
      .then(res => {
        if (res.status === 200) {
          this.visatypes.splice(index, 1)
        }
      })
      .catch(e => { console.log(e) })
    },
    editType: function (t) {
      this.$router.push('/visatype/' + t._id)
    },
    importType: function () {
      var vtype = null
      if (this.newTypeField.startsWith('visatype ')) {
        vtype = utils.methods.importType(this.newTypeField)
      } else {
        vtype = JSON.parse(this.newTypeField)
      }
      if (vtype && vtype.name && vtype.sections) {
        delete vtype['_id']
        var vm = this
        axios.post('/api/new/visatypes', vtype)
        .then(function (res) {
          if (res.status === 200) {
            vm.visatypes.push(res.data)
            vm.newTypeField = ''
          }
        })
        .catch(err => { console.log(err) })
      }
    },
    exportType: function (t) {
      var vtype = JSON.stringify(t, null, 2)
      var w = window.open()
      w.document.open()
      w.document.write('<html><body><pre>' + vtype + '</pre></body></html>')
      w.document.close()
    }
  }
}
</script>
<style scoped>
.visatype {
  border-radius: 3px;
  position: relative;
  margin: 0 0 1em 0;
}
.visatype h3 a {
  color: #fff;
  font-size: 0.6em;
  padding: 1em 0 0 1em;
  display: block;
  border-radius: 3px;
  background-color: #136efb;
  position: relative;
  height: 54px;
  width: 100%
}
.visatype h3 a:hover {
  text-decoration: none;
  background: #0358d8;
  color: #fff!important
}
.tile-action {
  position: absolute;
  bottom: 0;
  right: 1em;
  height: 63px;
  padding: 18px 0 0 0;
}
.tile-action .btn {
  border: none;
  outline: none;
  background: none;
  color: #fff;
}
.tile-action button.btn i {
 
}
.tile-action button.btn i:hover {
  color: #222
}
</style>



// WEBPACK FOOTER //
// visatypes.vue?3ac37780